import { FC } from "preact/compat";
import { useErrorBoundary } from "preact/hooks";
import { Button } from "../Button";

const ErrorBoundary: FC = ({ children }) => {
    const [error, resetError] = useErrorBoundary();

    if (!error) {
        return <>{children}</>;
    }

    const message = error instanceof Error ? error.message : String(error);

    return (
        <div className="w-full h-full p-8">
            <div className="flex items-center gap-x-4 mb-4">
                <div className="h-12 w-1 rounded bg-red-500" />
                <h1 className="text-2xl font-semibold text-red-500">
                    An error occurred
                </h1>
            </div>
            <p className="mb-4 text-lg">
                Please contact your system administrator and let us know about
                this issue.
            </p>
            <p className="text-gray-500 mb-2">Technical details: {message}</p>
            {error instanceof Error && error.stack && (
                <pre className="p-2 bg-gray-100 rounded text-sm">
                    {error.stack}
                </pre>
            )}
            <div className="flex mt-8">
                <Button onClick={resetError}>Try again</Button>
            </div>
        </div>
    );
};

export default ErrorBoundary;
